import { SmartIdWizardErrorHandler } from "components/account/SmartId/Shared/SmartIdWizardErrorHandler";
import React, { useState } from "react";
import StepWizard from "react-step-wizard";
import { NO_TRANSITIONS } from "components/tools/wizards/wizardTransitions";
import { SmartIdPersonalCodeStep } from "components/account/SmartId/Adding/SmartIdPersonalCodeStep";
import { useSmartIdLoginLogic } from "./useSmartIdLoginLogic";
import { SmartIdVerificationStep } from "components/account/SmartId/Shared/SmartIdVerificationStep";

export function SmartIdLoginWizard(props) {
  const [wizard, setWizard] = useState(null);
  
  const {
    pin,
    sessionPollingError,
    isAuthenticating,
    personalCodeEntryError,
    setPersonalCodeEntryError,    
    handlePersonalCodeSubmit,
    resetError
  } = useSmartIdLoginLogic(wizard, props.legalEntityId);

  const handleErrorNavigation = () => {
    setPersonalCodeEntryError("");
    resetError();
    wizard.goToStep(1);
  };

  return (
    <SmartIdWizardErrorHandler
      error={sessionPollingError}
      onPrimaryButtonClick={handleErrorNavigation}
      buttonTextKey="email_hint_page_try_again_btn"
      >
      <StepWizard instance={setWizard} transitions={NO_TRANSITIONS}>        
        <SmartIdPersonalCodeStep
          onPersonalCodeSubmit={handlePersonalCodeSubmit}
          onPersonalCodeUpdated={() => setPersonalCodeEntryError("")}
          legalEntityId={props.legalEntityId}
          errorMessage={personalCodeEntryError}
          titleTextKey="personal_code_entry_page_info"
        />        
        <SmartIdVerificationStep
          pin={pin}
          isWaiting={isAuthenticating}          
          titleTextKey="smart_id_verification_prompt_view_title"
        />
      </StepWizard>
    </SmartIdWizardErrorHandler>
  );
}